<ng-container [formGroup]="formGroup">
  <!-- Html editor -->
  <div *ngIf="formItem.type == 'group' && !formItem.hide && formItem.groupList"
    [class]="'col-12 ' + formItem.globalClass" class="mb-3" [ngClass]="{ isDisable: formItem.isDisable }">
    <div class="fw-bold bg-transparent mb-2" *ngIf="formItem.label != null">
      <span>{{ formItem.label | translate }}</span>
    </div>
    <div class="group-card mb-3 rounded-3">
      <div class="alert alert-primary mt-2" [class]="formItem.alertClass"
        *ngIf="formItem.alertMessage && formItem.hasAlert">
        <span>{{ formItem.alertMessage | translate }}</span>
      </div>
      <div class="row pt-3 px-3">
        <ng-container *ngFor="let formItem of formItem.groupList; let i = index">
          <app-form-field [files]="files" *ngIf="!formItem.hide" [class]="formItem.widthClass ?? 'col-12 '"
            [formGroup]="formGroup" [formItem]="formItem" (onLabelClick)="labelClick(formItem, formItem)"
            [validationErrors]="validationErrors" (onAddFormArray)="addGroupFormArray(i)"
            (onRemoveFormArray)="removeGroupFormArray(i, $event)"></app-form-field>
        </ng-container>
      </div>
      <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
      <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem)
        }}</span>
    </div>
  </div>
  <!-- Html editor -->
  <div *ngIf="formItem.type == 'htmlEditor' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="form-group mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
    <ckeditor [ngClass]="{ 'is-invalid': getError(formItem) }" [(ngModel)]="formItem.defaultValue"
      formControlName="{{ formItem.name }}" [attr.type]="formItem.type" [class]="formItem.inputClass ?? 'form-control'"
      [id]="formItem.name">
    </ckeditor>
    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- text , number , email , password -->
  <div *ngIf="isSimpleItem(formItem.type) && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="form-group mb-3" style="position: relative">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label"
      [class]="'form-label ' + formItem.labelClass"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.labelIcon" [innerHTML]="formItem.labelIcon"></span>
      <span *ngIf="formItem.isRequired">*</span></label>
    <div *ngIf="formItem.fixedHint" class="text-secondary">{{ formItem.hint ?? '' | translate }}</div>
    <div class="position-relative">
      <input *ngIf="formItem.type == 'number'" (keydown)="validateKeyInputTypeNum($event)" #inpt
        [class]="formItem.inputClass ?? 'form-control'" autocomplete="new-password"
        [minLength]="formItem['minLength'] ?? 0" [maxLength]="formItem['maxValue'] ?? 1000"
        [ngClass]="{ 'is-invalid': getError(formItem), 'prefix-space': cntryCode }"
        formControlName="{{ formItem.name }}" [attr.type]="formItem.type"
        (paste)="stopPaste($event, formItem); validatePasteTypeNum($event)" [id]="formItem.name"
        placeholder="{{ formItem.placeholder ?? '' | translate }}" />
      <div class="mobile-prefix" *ngIf="cntryCode">{{ cntryCode }}</div>
      <ng-container *ngIf="formItem.type != 'number'">
        <input #inpt [class]="formItem.inputClass ?? 'form-control'" autocomplete="new-password"
          [minLength]="formItem['minLength'] ?? 0" [maxLength]="formItem.maxValue ?? 1000"
          [ngClass]="{ 'is-invalid': getError(formItem), 'prefix-space': cntryCode }"
          formControlName="{{ formItem.name }}" [attr.type]="formItem.type" (paste)="stopPaste($event, formItem)"
          [id]="formItem.name" placeholder="{{ formItem.placeholder ?? '' | translate }}" />
        <div class="eye-password clickable my-2" *ngIf="formItem.type == 'password' && inpt.value">
          <div class="mobile-prefix" *ngIf="cntryCode">{{ cntryCode }}</div>
          <i class="pi pi-eye" *ngIf="inpt.type == 'text'" (click)="inpt.type = 'password'"></i>
          <i class="pi pi-eye-slash" *ngIf="inpt.type == 'password'" (click)="inpt.type = 'text'"></i>
        </div>
      </ng-container>
      <div class="custom-field-template" *ngIf="formItem.customFieldTemplate && formItem.customFieldTemplate.template"
        (click)="
          formItem.customFieldTemplate && formItem.customFieldTemplate.handleClick && !formItem['disableClick']
            ? formItem.customFieldTemplate.handleClick(formItem, formGroup)
            : null
        " [innerHTML]="formItem.customFieldTemplate.template(formGroup)"></div>
    </div>
    <button *ngIf="formItem.isOptionalButton" class="btn btn-primary my-1" [class]="formItem.optionalButtonClass"
      (click)="formItem.optionalButtonClick ? formItem.optionalButtonClick(formGroup) : null">
      {{ formItem.optionalButtonName ?? '' | translate }}
    </button>
    <span *ngIf="!getError(formItem) && !formItem.fixedHint" class="text-secondary">
      {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- Start Mobile Number Field -->
  @if (formItem.type == 'mobileNumber' && !formItem.hide) {
  <div id="phone-dialog" [class]="'col-12 ' + formItem.globalClass" class="form-group mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label"
      [class]="'form-label ' + formItem.labelClass"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }}
      <span *ngIf="formItem.labelIcon" [innerHTML]="formItem.labelIcon"></span>
      <span *ngIf="formItem.isRequired">*</span>
    </label>
    <div class="position-relative d-flex align-items-center">
      <!-- Country Selector Dropdown -->
      <div [formGroup]="countryForm" class="position-absolute ms-1 pe-1">
        <p-dropdown [options]="countries.slice(0, 2)" formControlName="selectedCountry" optionLabel="name"
          [filter]="true" filterPlaceholder="Search country" [showClear]="false" appendTo="body" placeholder="code"
          [ngClass]="dropdownClasses">
          <!-- Custom Template for Dropdown Items -->
          <ng-template let-country pTemplate="customCountryTemplate">
            <div class="d-flex align-items-center gap-1">
              <!-- Flag Image -->
              <img [src]="countryURLFlag(country)" alt="Flag" width="35" height="25" />
              <!-- Country Name and Dial Code -->
              <span class="d-flex align-items-center gap-1">
                <span>{{ country.name }}</span>
                <span>({{ country.dial_code }})</span>
              </span>
            </div>
          </ng-template>

          <!-- Custom Template for Selected Item -->
          <ng-template let-country pTemplate="selectedItem">
            <div *ngIf="country" class="d-flex align-items-center gap-1">
              <!-- Display Flag and Dial Code When Country Selected -->
              <img [src]="countryURLFlag(country)" alt="Country Flag" width="35" height="25" />
              <span>{{ country.dial_code }}</span>
            </div>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Mobile Input -->
      <input type="text" [formControlName]="formItem.name" [placeholder]="formItem.placeholder ?? '' | translate"
        class="form-control" inputmode="numeric" pattern="[0-9]*" (keypress)="allowOnlyNumbers($event)"
        (paste)="preventNonNumericPaste($event)" />
    </div>
    <!-- Hint and Validation -->
    <div *ngIf="formItem.hint && !getError(formItem)" class="text-secondary">
      {{ formItem.hint | translate }}
    </div>
    <div *ngIf="getError(formItem)" class="text-danger error-label fs-14">
      {{ getError(formItem) }}
    </div>
  </div>
  }
  <!-- End Mobile Number Field -->

  <!-- number (PrimeNG InputNumber) -->
  <div *ngIf="formItem.type == 'number' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="form-group mb-3" style="position: relative">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label"
      [class]="'form-label ' + formItem.labelClass"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.labelIcon" [innerHTML]="formItem.labelIcon"></span>
      <span *ngIf="formItem.isRequired">*</span></label>
    <div *ngIf="formItem.fixedHint" class="text-secondary">{{ formItem.hint ?? '' | translate }}</div>
    <div class="position-relative">
      <p-inputNumber [formControlName]="formItem.name" [min]="formItem.minValue" [max]="formItem.maxValue"
        [placeholder]="formItem.placeholder ?? '' | translate" [class]="formItem.inputClass ?? 'form-control'"
        [suffix]="formItem.suffix" inputId="{{ formItem.name }}" [minFractionDigits]="formItem.minFractionDigits"
        [maxFractionDigits]="formItem.maxFractionDigits" [useGrouping]="formItem.useGrouping">
      </p-inputNumber>
    </div>
    <span *ngIf="!getError(formItem) && !formItem.fixedHint" class="text-secondary">
      {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- range -->
  <div *ngIf="formItem.type == 'range' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass" class="mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
    <input [ngClass]="{ 'is-invalid': getError(formItem) }" formControlName="{{ formItem.name }}"
      [attr.type]="formItem.type" [attr.max]="formItem.maxValue" [attr.min]="formItem.minValue" class="form-range"
      [class]="formItem.inputClass ?? ''" [id]="formItem.name" />
    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- checkbox , toggel -->
  <div *ngIf="(formItem.type == 'checkbox' || formItem.type == 'toggleButton') && !formItem.hide"
    [class]="'col-12 ' + formItem.globalClass" [ngClass]="{ 'form-switch': formItem.type == 'toggleButton' }"
    class="mb-3">
    <div class="form-check fix-field-align">
      <input [ngClass]="{ 'is-invalid': getError(formItem), activeToggle: activeToggle ? 'activeToggle' : '' }"
        formControlName="{{ formItem.name }}" type="checkbox" class="form-check-input"
        [class]="formItem.inputClass ?? ''" [id]="formItem.name" [checked]="activeToggle"
        (change)="onToggleChange($event)" />
      <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label"
        [ngClass]="{ clickable: formItem.enabilLabelClick }" class="form-check-label">
        {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span>
      </label>
    </div>
    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- date time picker -->
  <div *ngIf="formItem.type == 'dateTime' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass" class="mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span>
    </label>
    <p-calendar [placeholder]="formItem.placeholder" class="w-100" [formControlName]="formItem.name"
      [showButtonBar]="true" [class]="formItem.inputClass ?? ''" [readonlyInput]="false" [showIcon]="true"
      [minDate]="formItem.minValue ? (formItem.minValue === 'today' ? todayDate : formItem.minValue) : null"
      [maxDate]="formItem.maxValue ? (formItem.maxValue === 'today' ? todayDate : formItem.maxValue) : null"
      appendTo="body">
    </p-calendar>
    <span *ngIf="!getError(formItem)" class="text-secondary">{{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error">{{ getError(formItem) }}</span>
  </div>
  <!-- -------- -->
  <!-- date -->
  <!-- <div *ngIf="formItem.type == 'date' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass" class="mb-3">
        <label [attr.for]="formItem.name" (click)="labelClick($event ,formItem)" *ngIf="formItem.label"
            class="form-label"
            [ngClass]="{'text-danger' : getError(formItem), 'clickable' : formItem.enabilLabelClick}"><span
                *ngIf="formItem.isRequired">*</span> {{ formItem.label | translate
            }}</label>
        <div class="input-group">
            <input [ngClass]="{'is-invalid' : getError(formItem)}" class="form-control" [minDate]="formItem.minValue"
                [maxDate]="formItem.maxValue" (click)="d.toggle()"
                placeholder="{{formItem.placeholder ?? 'yyyy-mm-dd' | translate}}" name="dp"
                formControlName="{{ formItem.name }}" ngbDatepicker #d="ngbDatepicker">
            <button class="input-group-text" (click)="d.toggle()" type="button">
                <i class="feather icon-calendar icon-md text-muted"></i>
            </button>
        </div>
        <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
        <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
    </div> -->

  <!-- rang date -->
  <div *ngIf="formItem.type == 'dateRange' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass" class="mb-3">
    <div class="row">
      <label *ngIf="formItem.label" [attr.for]="formItem.name" (click)="labelClick($event, formItem)"
        [class]="'form-label ' + formItem.labelClass"
        [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
        {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>

      <div [class]="formItem.inlineWidthClass">
        <app-date-range [autoApply]="formItem.autoApply ?? false"
          [placeholder]="formItem.placeholder ?? 'Date from - to'"
          [timePickerIncrement]="formItem.timePickerIncrement ?? 30" [isTimeOnly]="formItem.isTimeOnly ?? false"
          [hideButtonClasses]="formItem.hideDaterangeBtnClass ?? false" [monthDateLimit]="formItem.monthDateLimit ?? 12"
          [openInModal]="formItem.openInModal ?? false" [hasTime]="formItem.hasTime ?? true"
          [classDate]="getError(formItem) ? 'is-invalid' : ''" (click)="changeTouche(formItem.name)"
          [minValue]="formItem.minValue" [defaultValue]="formItem.defaultValue" [maxValue]="formItem.maxValue"
          (onDateChange)="changeValue($event, formItem.name)"></app-date-range>
      </div>
      <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
      <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem)
        }}</span>
    </div>
  </div>

  <!-- year - month -->
  <div *ngIf="formItem.type == 'year_month' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass" class="mb-3">
    <div class="row">
      <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label"
        [class]="'form-label ' + formItem.labelClass"
        [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
        {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span>
      </label>
      <div [class]="formItem.inlineWidthClass">
        <year-month-picker (click)="changeTouche(formItem.name)" [defaultValue]="formItem.defaultValue"
          [minValue]="formItem.minValue" [maxValue]="formItem.maxValue"
          (onDateChange)="changeValue($event, formItem.name)"></year-month-picker>
      </div>
      <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
      <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem)
        }}</span>
    </div>
  </div>

  <!-- custom year - month -->
  <div *ngIf="formItem.type == 'custom_year_month' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="mb-3">
    <div class="row">
      <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label"
        [class]="'form-label ' + formItem.labelClass"
        [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
        {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
      <div [class]="formItem.inlineWidthClass">
        <custom-year-month-picker (click)="changeTouche(formItem.name)" [defaultValue]="formItem.defaultValue"
          [minValue]="formItem.minValue" [maxValue]="formItem.maxValue"
          (onDateChange)="changeValue($event, formItem.name)"></custom-year-month-picker>
      </div>
    </div>
  </div>

  <!-- custom range year - month -->
  <div *ngIf="formItem.type == 'range_year_month' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="mb-3">
    <div class="row">
      <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label"
        [class]="'form-label ' + formItem.labelClass"
        [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
        {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
      <div [class]="formItem.inlineWidthClass">
        <range-year-month-picker (click)="changeTouche(formItem.name)" [defaultValue]="formItem.defaultValue"
          [minValue]="formItem.minValue" [maxValue]="formItem.maxValue"
          (onDateChange)="changeValue($event, formItem.name)"></range-year-month-picker>
      </div>
    </div>
  </div>

  <!-- drop File -->
  <div *ngIf="formItem.type == 'dropFile' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass" class="mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
    <div class="">
      <app-drop-drag-files (onClick)="changeValue($event, formItem.name)" [fileAddedBefore]="fileAddedBeforeArrayMuti"
        [reset]="!!!formGroup.get(formItem.name)?.value" [cacheFiles]="formItem.fileConfig?.cacheFiles"
        [previewImg]="formItem.fileConfig?.previewImg ?? false" [keepFile]="formItem.fileConfig?.keepFile ?? true"
        [maxFiles]="formItem.maxValue" (onClick)="changeTouche(formItem.name)"
        (onReset)="formGroup.get(formItem.name)?.setValue([])" (fileRemoved)="onRemoveFile($event)"
        [formItem]="formItem" [hint]="formItem.hint" (fileAdded)="onUploadSuccess($event)"
        [accepts]="formItem.fileConfig?.allowedExtension ?? ['*']"></app-drop-drag-files>
      <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem)
        }}</span>
    </div>
  </div>

  <!-- Start Upload Single File -->
  @if (formItem.type === 'file' && !formItem.hide) {
  <div id="single-upload" [class]="'col-12 ' + formItem.globalClass" class="form-group mb-3">
    <!-- Label -->
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }}
      <span *ngIf="formItem.isRequired">*</span>
    </label>

    @if (!isLoadingUploadFile) {
    <!-- Drag & Drop Upload Box -->
    @if (formItem.fileConfig?.shape == 'circle') {
    <div class="upload-box-circle" (click)="triggerFileUpload()" (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)" [ngClass]="{ dragging: isDragging }">
      @if (!savedSingleFile) {
      <i class="pi pi-cloud-upload"></i>
      }
      @if (savedSingleFile) {
      <div class="positioned-icon">
        <div class="icon-box">
          <i class="pi pi-pencil"></i>
        </div>
      </div>
      }
      <!-- <span>
        <span class="clickToUpload">Click to upload </span>
        <span class="dragDrop">or Drag & Drop</span>
      </span> -->

      @if (savedSingleFile?.type?.includes('image')) {
      <div class="image-preview-box">
        <!-- Image Preview -->
        <img class="loaded" [src]="savedSingleFile?.objectURL ?? 'assets/images/icons/attachment-image.svg'"
          alt="Image Icon" />
      </div>
      }

      <input type="file" #fileInput (change)="changeFile($event)" hidden
        [accept]="formItem.fileConfig?.allowedExtension ?? '*'" />
    </div>
    }

    @if (formItem.fileConfig?.shape !== 'circle') {
    @if (formItem.fileConfig?.shape == 'custom-document') {
    <div class="custom-document-upload-box" (click)="triggerFileUpload()" (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)" [ngClass]="{ dragging: isDragging }">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
        <g clip-path="url(#clip0_3314_13964)">
          <path
            d="M16.6253 5.11335L13.7212 2.20919C12.6195 1.10752 11.1545 0.500855 9.59616 0.500855H5.83366C3.53616 0.500021 1.66699 2.36919 1.66699 4.66669V16.3334C1.66699 18.6309 3.53616 20.5 5.83366 20.5H14.167C16.4645 20.5 18.3337 18.6309 18.3337 16.3334V9.23752C18.3337 7.67919 17.727 6.21585 16.6253 5.11335ZM15.447 6.29169C15.712 6.55669 15.9362 6.85085 16.1178 7.16669H12.5003C12.0412 7.16669 11.667 6.79252 11.667 6.33335V2.71585C11.9828 2.89752 12.2778 3.12169 12.542 3.38669L15.4462 6.29085L15.447 6.29169ZM16.667 16.3334C16.667 17.7117 15.5453 18.8334 14.167 18.8334H5.83366C4.45533 18.8334 3.33366 17.7117 3.33366 16.3334V4.66669C3.33366 3.28835 4.45533 2.16669 5.83366 2.16669H9.59616C9.73199 2.16669 9.86699 2.17335 10.0003 2.18585V6.33335C10.0003 7.71169 11.122 8.83335 12.5003 8.83335H16.6478C16.6603 8.96669 16.667 9.10169 16.667 9.23752V16.3334ZM13.0895 12.5675C13.4153 12.8934 13.4153 13.42 13.0895 13.7459C12.927 13.9084 12.7137 13.99 12.5003 13.99C12.287 13.99 12.0737 13.9084 11.9112 13.7459L10.8337 12.6684V16.3334C10.8337 16.7934 10.4603 17.1667 10.0003 17.1667C9.54033 17.1667 9.16699 16.7934 9.16699 16.3334V12.6684L8.08949 13.7459C7.76366 14.0717 7.23699 14.0717 6.91116 13.7459C6.58533 13.42 6.58533 12.8934 6.91116 12.5675L8.25616 11.2225C9.21783 10.2609 10.7828 10.2609 11.7453 11.2225L13.0903 12.5675H13.0895Z"
            fill="#3980F4" />
        </g>
        <defs>
          <clipPath id="clip0_3314_13964">
            <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
          </clipPath>
        </defs>
      </svg>
      <span class="d-flex flex-column flex-wrap gap-1">
        <span class="input-attention d-flex flex-row flex-wrap gap-1">
          <span class="text-main"> {{'GENERAL.ATTACH' | translate}} </span>
          {{'GENERAL.FILE_OR_IMAGE_HERE' | translate}}
        </span>
        <span class="input-hint text-wrap">
          {{ formItem.fileConfig?.inputHint || '' }}
        </span>
      </span>
      <input type="file" #fileInput (change)="changeFile($event)" hidden
        [accept]="formItem.fileConfig?.allowedExtension ?? '*'" />
    </div>
    }
    @if (formItem.fileConfig?.shape !== 'custom-document') {
    <div class="upload-box" (click)="triggerFileUpload()" (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)" (drop)="onFileDrop($event)" [ngClass]="{ dragging: isDragging }">
      <i class="pi pi-cloud-upload"></i>
      <span>
        <span class="clickToUpload">Click to upload </span>
        <span class="dragDrop">or Drag & Drop</span>
      </span>
      <input type="file" #fileInput (change)="changeFile($event)" hidden
        [accept]="formItem.fileConfig?.allowedExtension ?? '*'" />
    </div>
    }
    }
    }

    @if (+isLoadingUploadFile) {
    @if (formItem.fileConfig?.shape !== 'circle') {
    <div class="upload-box d-block">
      <div class="row">
        <div class="col-2">
          <p-skeleton height="100%"></p-skeleton>
        </div>
        <div class="col-10">
          <p-skeleton styleClass="mb-2 mx-auto"></p-skeleton>
          <p-skeleton></p-skeleton>
        </div>
      </div>
    </div>
    }
    @if (formItem.fileConfig?.shape == 'circle') {
    <div class="upload-box-circle d-block">
      <div class="row">
        <div class="col-12">
          <p-skeleton height="100%"></p-skeleton>
        </div>
      </div>
    </div>
    }
    }
    <!-- Displaying Selected Files -->
    @if (formItem.fileConfig?.shape !== 'circle') {
    <div *ngIf="savedSingleFile && !isLoadingUploadFile">
      <div class="file-preview mt-2">
        <div class="file-info">
          <div class="file-icon">
            <!-- PDF Icon -->
            @if (savedSingleFile?.type?.includes('pdf') || savedSingleFile?.name?.endsWith('.pdf')) {
            <img class="fit-object-cover" src="assets/images/icons/pdficon.svg" alt="PDF Icon" />
            } @else if (
            savedSingleFile?.type?.includes('doc') ||
            savedSingleFile?.type === 'application/msword' ||
            savedSingleFile?.name?.includes('.doc')
            ) {
            <!-- Word Document Icon -->
            <img class="fit-object-cover" src="assets/images/icons/attachment-file.svg" alt="Word Icon" />
            } @else if (
            savedSingleFile?.type?.includes('excel') ||
            savedSingleFile?.type === 'application/vnd.ms-excel' ||
            savedSingleFile?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            savedSingleFile?.name?.includes('.xls') ||
            savedSingleFile?.name?.includes('.xlsx')
            ) {
            <!-- Excel File Icon -->
            <img class="fit-object-cover" src="assets/images/icons/attachment-xlsx.svg" alt="Excel Icon" />
            } @else if (savedSingleFile?.type?.includes('image')) {
            <!-- Image Preview -->
            <img class="fit-object-cover loaded"
              [src]="savedSingleFile?.objectURL ?? 'assets/images/icons/attachment-image.svg'" alt="Image Icon" />
            } @else {
            <!-- Default File Icon (for unsupported file types) -->
            <img class="fit-object-cover" src="assets/images/icons/attachments.svg" alt="Other Icon" />
            }
          </div>

          <div class="file-details">
            <p class="file-name">
              {{ savedSingleFile?.name || '' }}
            </p>
            <p class="file-size">
              {{ formatSizeUnits(savedSingleFile?.size) || '' }}
            </p>
          </div>
        </div>
        <!-- <div class="file-delete" (click)="removeFile()"> -->
        <div class="d-flex gap-2">
          <!-- @if(formItem.fileConfig?.shape == 'circle'){
          <button type="button" class="btn file-edit border-0" (click)="removeFile(formItem)">
            <i class="pi pi-pencil"></i>
          </button>
          } -->
          <button type="button" class="btn file-delete border-0" (click)="removeFile(formItem)">
            <i class="pi pi-trash"></i>
          </button>
          @if (formItem.addedBforeItems?.id) {
            <button type="button" class="btn file-edit border-0" (click)="downloadFile(formItem)">
              <i class="pi pi-arrow-down"></i>
            </button>
          }
        </div>
      </div>
    </div>
    }
    @if (!savedSingleFile && !getError(formItem) && formItem.hint) {
    <span class="file-hint">
      {{ formItem.hint || '' | translate }}
    </span>
    }
    <!-- <br /> -->
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error mt-1">
      {{ getError(formItem) }}
    </span>
  </div>
  }
  <!-- End Upload Single File -->

  <!-- radio -->
  <ng-container *ngIf="formItem.type == 'radio' && !formItem.hide">
    <div [class]="'col-12 ' + formItem.globalClass" class="mb-3 form-check-inline fix-field-align">
      <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
        [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
        {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span>
      </label>
      <div class="mb-3 form-check form-check-inline" [class]="radioItem.styleClass"
        *ngFor="let radioItem of formItem.listValues; let i = index">
        <input formControlName="{{ formItem.name }}" [value]="radioItem.value" type="radio" class="form-check-input"
          [class]="formItem.inputClass" [id]="formItem.name + i" />

        <label [attr.for]="formItem.name + i" (click)="labelClick($event, formItem)"
          [ngClass]="{ clickable: formItem.enabilLabelClick }" *ngIf="radioItem.label" class="form-check-label">
          {{ radioItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
      </div>
    </div>
    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </ng-container>

  <!-- select , multiSelect -->
  <div *ngIf="(formItem.type == 'select' || formItem.type == 'multiSelect') && !formItem.hide"
    [class]="'col-12 ' + formItem.globalClass" class="mb-3">
    <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 w-100 mb-2">
      <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label"
        class="form-label mb-0" [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
        {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
      @if (formItem.enableAddNewBtn) {
      <div id="add-new">
        <button type="button" class="btn btn-add-new gap-1" (click)="addNew(formItem)">
          <span class="pi pi-plus-circle"></span>
          Add New
        </button>
      </div>
      }
    </div>

    <ng-container *ngIf="formItem.type == 'select'">
      <p-dropdown class="d-block w-100" appendTo="body" [ngClass]="{ 'ng-dirty ng-invalid': getError(formItem) }"
        formControlName="{{ formItem.name }}" [id]="formItem.name" [virtualScroll]="false" [virtualScrollItemSize]="38"
        [loading]="false" [disabled]="false" [showClear]="true" [checkmark]="true" [filter]="true" filterBy="label"
        [options]="(formItem['listValuesCopy']?.length ? formItem['listValuesCopy'] : formItem.listValues) ?? []"
        formControlName="{{ formItem.name }}" optionLabel="label" optionValue="value"
        placeholder="{{ formItem.defaultValue ? '' : (formItem.placeholder ?? 'Select' | translate) }}"
        (onFilter)="onFilter($event, formItem.name, formItem['listValuesCopy'] || formItem.listValues)" />
    </ng-container>

    <ng-container *ngIf="formItem.type == 'multiSelect'">
      <p-multiSelect class="d-block w-100" appendTo="body" [ngClass]="{ 'ng-dirty ng-invalid': getError(formItem) }"
        formControlName="{{ formItem.name }}" [id]="formItem.name" [virtualScroll]="false" [virtualScrollItemSize]="38"
        [loading]="false" [disabled]="false" [showClear]="true" [filter]="true" filterBy="label"
        [options]="(formItem['listValuesCopy']?.length ? formItem['listValuesCopy'] : formItem.listValues) ?? []"
        optionLabel="label" optionValue="value"
        placeholder="{{ formItem.defaultValue ? '' : (formItem.placeholder ?? 'Select' | translate) }}"
        (onFilter)="onFilter($event, formItem.name, formItem['listValuesCopy'] || formItem.listValues)"
        (onChange)="onSelectionChange($event, formItem.name)">
      </p-multiSelect>
    </ng-container>

    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>
  <!-- Start Multi Select Tree -->
  <div *ngIf="formItem.type == 'multiSelectTree' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="form-group mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span>
    </label>
    <p-treeSelect class="d-block w-100" appendTo="body" [ngClass]="{ 'ng-dirty ng-invalid': getError(formItem) }"
      formControlName="{{ formItem.name }}" [id]="formItem.name" [disabled]="false" [filter]="true"
      [filterMode]="'lenient'"
      [options]="(formItem['listValuesCopy']?.length ? formItem['listValuesCopy'] : formItem.listTreeValues) ?? []"
      [selectionMode]="'checkbox'" (onNodeSelect)="onNodeSelect($event, formItem.name)"
      (onNodeUnselect)="onNodeUnselect($event, formItem.name)">
      <ng-template pTemplate="placeholder">
        {{ formItem.defaultValue || formItem.placeholder || ('Select' | translate) }}
      </ng-template>
    </p-treeSelect>
    <span *ngIf="!getError(formItem)" class="text-secondary">{{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error">{{ getError(formItem) }}</span>
  </div>
  <!-- End Multi Select Tree -->

  <!-- textarea -->
  <div *ngIf="formItem.type == 'textarea' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="form-group mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span>
    </label>
    <textarea [ngClass]="{ 'is-invalid': getError(formItem) }" formControlName="{{ formItem.name }}"
      [attr.type]="formItem.type" [class]="formItem.inputClass ?? 'form-control'" [id]="formItem.name"
      [attr.rows]="formItem.rows" [placeholder]="formItem.placeholder ?? '' | translate"></textarea>
    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- captch -->
  <div *ngIf="formItem.type == 'captcha' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="form-group mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">{{ formItem.label |
      translate }}</label>
    <!-- <ngx-recaptcha2 #captchaElem [hl]="currentLang" [siteKey]="siteKey"
            formControlName="{{ formItem.name }}"></ngx-recaptcha2> -->
    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- array -->
  <div *ngIf="formItem.type == 'array' && !formItem.hide" [ngClass]="{ isDisable: formItem.isDisable }"
    [class]="'col-12 ' + formItem.globalClass" class="form-group mb-3 row" formArrayName="{{ formItem.name }}">
    <div [class]="formItem.ArrayConfigration?.ledding?.leddingClass ?? 'd-flex justify-content-between'">
      <span [class]="formItem.ArrayConfigration?.ledding?.leddingClass ?? 'text-secondary'">
        {{ formItem.ArrayConfigration?.ledding?.label ?? '' | translate }}</span>
      <button *ngIf="
          formItem.ArrayConfigration?.maximumRowsNum
            ? (formItem.ArrayConfigration?.list?.length ?? 0) < (formItem.ArrayConfigration?.maximumRowsNum ?? 0)
            : true
        " [class]="'btn btn-sm ' + (formItem.ArrayConfigration?.ledding?.btnClass ?? '')" (click)="addFormArray()">
        {{ formItem.ArrayConfigration?.ledding?.btnText ?? '' | translate }}
        <i *ngIf="formItem.ArrayConfigration?.ledding?.btnIcon"
          [class]="formItem.ArrayConfigration?.ledding?.btnIcon"></i>
      </button>
    </div>
    <div class="alert alert-primary mt-2" [class]="formItem.alertClass"
      *ngIf="formItem.alertMessage && formItem.hasAlert">
      <span>{{ formItem.alertMessage | translate }}</span>
    </div>
    <div class="" *ngIf="(formItem.ArrayConfigration?.list?.length ?? 0) > 0">
      <ng-container *ngFor="let itemLevelOne of formItem.ArrayConfigration?.list; let indexForm = index"
        [formGroupName]="indexForm">
        <div class="row form-array-item" [class]="formItem.ArrayConfigration?.itemClass ?? ''">
          <div *ngIf="(formItem.ArrayConfigration?.list?.length ?? 0) > 1" class="remove-item" dir="ltr">
            <div class="text-danger error-label fs-14" placement="bottom" (click)="removeFormArray(indexForm)">
              <i class="mdi mdi-close fa-lg"></i>
            </div>
          </div>
          <ng-container *ngFor="let itemLevelTwo of itemLevelOne; let i = index">
            <app-form-field *ngIf="!itemLevelTwo.hide" [ListLoadChanged]="ListLoadChanged"
              (includeValueInput)="includeUniqueValue($event)" (execludeValue)="execlude($event)"
              [crntFieldIndex]="indexForm" [files]="files" [class]="itemLevelTwo.widthClass ?? 'col-12 '"
              [formGroup]="getFormArray(indexForm)" [formItem]="itemLevelTwo"
              (onLabelClick)="labelClick(formItem, formItem)" [validationErrors]="validationErrors">
            </app-form-field>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- input chips -->
  <!-- <div *ngIf="formItem.type == 'chips' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass" class="form-group mb-3">
        <label [attr.for]="formItem.name" (click)="labelClick($event ,formItem)" *ngIf="formItem.label" class="form-label" [ngClass]="{'text-danger' : getError(formItem), 'clickable' : formItem.enabilLabelClick}"><span *ngIf="formItem.isRequired">*</span> {{ formItem.label | translate
  }} </label>
        <tag-input [identifyBy]="'item'" [displayBy]="'item'" [addOnBlur]="true" #chips theme="bootstrap" [separatorKeyCodes]="[32, 188,1]" [modelAsStrings]="false" (onAdd)="onAddChip($event,formItem.name)" [validators]="formItem.chipsOptions?.validations|| []" [errorMessages]="formItem.chipsOptions?.errorMessages" [ngClass]="{'is-invalid' : getError(formItem)}"
            formControlName="{{ formItem.name }}" secondaryPlaceholder="{{formItem.placeholder ?? '' | translate}}" placeholder="{{formItem.placeholder ?? '' | translate}}" [class]="formItem.inputClass ?? ''">
            <ng-template  let-item="item" let-index="index">
                <div class="custom-tag" [ngClass]="{'red-label' : item.label == 'invalid'}">
                    <span ngClass="tag-tooltip" *ngIf="item.label == 'invalid'" container="body"
                    class="info-btn" triggers="hover" placement="top" ngbTooltip="{{item.tip | translate}}"
                    ></span>
                    <span >
                    {{ item.item }}
                </span>
                <delete-icon class="delete-icon" (click)="chips.removeItem(item, index)"></delete-icon>
                </div>
            </ng-template>
        </tag-input>

        <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
        <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
    </div> -->

  <!-- input mask -->
  <!-- <div *ngIf="formItem.type == 'mask' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
        class="form-group mb-3">
        <label [attr.for]="formItem.name" (click)="labelClick($event ,formItem)" *ngIf="formItem.label"
            class="form-label"
            [ngClass]="{'text-danger' : getError(formItem), 'clickable' : formItem.enabilLabelClick}"><span
                *ngIf="formItem.isRequired">*</span> {{ formItem.label | translate}}
        </label>

        <input [mask]="formItem.mask" [patterns]="formItem.maskPattern" [allowNegativeNumbers]="true"
            [placeholder]="formItem.placeholder" [ngClass]="{'is-invalid' : getError(formItem)}"
            formControlName="{{ formItem.name }}" [attr.type]="formItem.type"
            [class]="formItem.inputClass ?? 'form-control'" [id]="formItem.name" [attr.rows]="formItem.rows" />
        <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
        <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
    </div> -->

  <!-- input autoComplete -->
  <!-- <div *ngIf="formItem.type == 'autoComplete' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
        class="form-group mb-3">
        <label [attr.for]="formItem.name" (click)="labelClick($event ,formItem)" *ngIf="formItem.label"
            class="form-label"
            [ngClass]="{'text-danger' : getError(formItem), 'clickable' : formItem.enabilLabelClick}"> <span
                *ngIf="formItem.isRequired">*</span> {{ formItem.label | translate}}
        </label>
        <div class="inp-autoComplete">
            <input #ngbType [value]="formItem.defaultValue??''" [showHint]="true" [ngbTypeahead]="autoCompleteSearch"
                [inputFormatter]="formatter" [resultFormatter]="formatter" (selectItem)="selectedItem($event,formItem)"
                placeholder="{{formItem.placeholder ?? '' | translate}}" [ngClass]="{'is-invalid' : getError(formItem)}"
                [class]="formItem.inputClass ?? 'form-control'" [id]="formItem.name" [attr.rows]="formItem.rows" />
            <i *ngIf="ngbType.value" (click)="[selectedItem({item:{value:null}},formItem),ngbType.value='']"
                class="clear-autoComplete mdi mdi-close" [ngClass]="currentLang == 'ar'?'clear-ltr':'clear-rtl'"></i>
        </div>
        <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
        <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
    </div> -->
  <!-- input autoComplete text -->
  <!-- <div *ngIf="formItem.type == 'auto_complete_text' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass" class="form-group mb-3">
        <label [attr.for]="formItem.name" (click)="labelClick($event ,formItem)" *ngIf="formItem.label" class="form-label" [ngClass]="{'text-danger' : getError(formItem), 'clickable' : formItem.enabilLabelClick}"> <span *ngIf="formItem.isRequired">*</span> {{ formItem.label | translate}}
        </label>
        <div class="inp-autoComplete">
            <input [container]="'body'" formControlName="{{ formItem.name }}"  class="form-control" [inputFormatter]="formatter" [resultFormatter]="formatter" (selectItem)="selectedItem($event,formItem)" [ngClass]="{'is-invalid' : getError(formItem)}" [ngbTypeahead]="autoCompleteSearch" [placeholder]="formItem.placeholder" />
        </div>
        <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
        <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
      </div> -->

  <!-- map -->
  <div *ngIf="formItem.type == 'map' && !formItem.hide" class="col-12 form-group mb-3">
    <label (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span>
    </label>
    <app-map mapType="select" [Locations]="formItem.locations ?? null"
      (emitLocation)="locationChange($event, formItem.name)"
      [enableQuickLatLongSearch]="!!formItem.enableQuickLatLongSearch"></app-map>
    <span *ngIf="!getError(formItem)" class="text-secondary">{{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error">{{ getError(formItem) }}</span>
  </div>

  <!-- select-scroll -->
  <div *ngIf="formItem.type == 'select-scroll' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
    <ng-select (close)="onSelectScrollClose()" appendTo="body" [id]="formItem.name" [loadingText]="'Loading more...'"
      [loading]="scrollData.loading" [virtualScroll]="formItem.loadOnScroll ?? false"
      (scrollToEnd)="getDynamicLoadData('')" [searchFn]="customSearchFn" (search)="onSearch($event)"
      (clear)="[(scrollData.reset = true), getDynamicLoadData('', 1)]" [ngClass]="{ 'has-warning': getError(formItem) }"
      [clearable]="true" formControlName="{{ formItem.name }}"
      [items]="(formItem['listValuesCopy'] ? formItem['listValuesCopy'] : formItem.listValues) ?? []" bindLabel="label"
      bindValue="value" placeholder="{{ formItem.placeholder ?? '' | translate }}" [class]="formItem.inputClass ?? ''">
      <!-- [multiple]="formItem.isMulti" -->
      <ng-template ng-header-tmp *ngIf="scrollData.totalCount">
        <small class="form-text text-muted">{{ 'Loaded' | translate }}
          {{ (formItem['listValuesCopy'] ? formItem['listValuesCopy'] : formItem.listValues).length }}
          {{ 'of' | translate }} {{ scrollData.totalCount }}</small>
      </ng-template>
      <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label"><img [src]="item.picture" *ngIf="item.picture" width="20px" height="20px" />
          {{ item.label | translate }}</span>
        <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
      </ng-template>
    </ng-select>
    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- readonly input -->
  <div *ngIf="formItem.type == 'readOnly' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="form-group mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
    <input [ngClass]="{ 'is-invalid': getError(formItem) }" formControlName="{{ formItem.name }}" [attr.disabled]="true"
      readonly [class]="formItem.inputClass ?? 'form-control'"
      placeholder="{{ formItem.placeholder ?? '' | translate }}" />
    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- time input -->
  <div *ngIf="formItem.type == 'time' && !formItem.hide" [class]="'col-12 ' + formItem.globalClass"
    class="form-group mb-3">
    <label [attr.for]="formItem.name" (click)="labelClick($event, formItem)" *ngIf="formItem.label" class="form-label"
      [ngClass]="{ 'text-danger': getError(formItem), clickable: formItem.enabilLabelClick }">
      {{ formItem.label | translate }} <span *ngIf="formItem.isRequired">*</span></label>
    <app-time-picker [ngClass]="{ 'is-invalid': getError(formItem) }" formControlName="{{ formItem.name }}"
      [class]="formItem.inputClass ?? ''"></app-time-picker>
    <span *ngIf="!getError(formItem)" class="text-secondary"> {{ formItem.hint ?? '' | translate }}</span>
    <span *ngIf="getError(formItem)" class="text-danger error-label fs-14 error"> {{ getError(formItem) }}</span>
  </div>

  <!-- viewText -->
  <div *ngIf="formItem.type == 'viewText' && !formItem.hide" class="col-12" class="form-group text-center">
    <span class="text-secondary"> {{ formItem.name | translate }}</span>
  </div>
  <span *ngIf="formError" class="text-danger error-label fs-14 mb-2"> {{ formError | translate }}</span>
</ng-container>
